import { render, staticRenderFns } from "./addCaseProblemToCaseModal.vue?vue&type=template&id=0a031249&"
import script from "./addCaseProblemToCaseModal.vue?vue&type=script&lang=js&"
export * from "./addCaseProblemToCaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports